import React, { useRef, useLayoutEffect, memo } from 'react';
import { FixedSizeList as TBody } from 'react-window';
import memoize from 'memoize-one';
import cssClasses from './body.css';
import Empty from './Empty/empty';
import isEqual from 'lodash.isequal';
import Row from './Row/row';

const propsAreEqual = (prev, next) => {
    if ((prev.data.props.focusedCell.coords.x !== null && prev.data.props.focusedCell.coords.x === prev.index)
        || (next.data.props.focusedCell.coords.x !== null && next.data.props.focusedCell.coords.x === next.index)
        || (prev.data.props.rowsVersion !== next.data.props.rowsVersion))
        return false;
    return isEqual(prev.data.props.rows[prev.index], next.data.props.rows[next.index])
        && JSON.stringify(prev.data.props.columns)=== JSON.stringify(next.data.props.columns);
}

const RowItem = memo(({ data, index, style, isScrolling }) => {
    const loadingRow = <div className={cssClasses.placeHolderRow} style={style}>{data.loadingColumns}</div>
    return <Row
            index={index}
            style={style}
            rows={data.props.rows}
            columns={data.props.columns}
            height={data.props.height}
            rowheight={data.props.rowheight}
            columnWidthList={data.props.columnWidthList}
            focusedCell={data.props.focusedCell}
            setCellDirectly={data.props.setCellDirectly}
            resizingColumn={data.props.resizingColumn}
            loadingRow={loadingRow}
            disabledCellChecker={data.props.disabledCellChecker}
            getRowKey={data.props.getRowKey}
            contextMenuId={data.props.contextMenuId} />
}, propsAreEqual);

const createItemData = memoize((props, loadingColumns) => ({
    props,
    loadingColumns,
}));

const Body = (props) => {
    const listRef = useRef(undefined);
    const loadingColumns = []
    props.columns.map((column, y) => {
        loadingColumns.push(<div key={y} className={cssClasses.placeHolderCell} style={{ width: props.columnWidthList[column.id] + 'px' }}><div className={cssClasses.elementPlaceHolder}></div></div>);
    });

    useLayoutEffect(() => {
        if (Number.isInteger(props.focusedCell.coords.x)) {
            listRef.current &&
                listRef.current.scrollToItem(props.focusedCell.coords.x);
        }
    }, [props.focusedCell])

    const itemData = createItemData(props, loadingColumns);

    if (props.rows && props.rows.length > 0)
        return <TBody
            ref={listRef}
            height={props.height}
            itemCount={props.rows.length}
            itemSize={props.rowheight}
            className={cssClasses.table}
            overscanCount={3}
            useIsScrolling={props.placeholderOnScroll}
            itemData={itemData} >
            {RowItem}
        </TBody>
    else return <Empty />
}

export default Body;



// WEBPACK FOOTER //
// ./src/components/DataTable/Body/body.js